'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { IPaginatedData } from '../../models/ICommon';
import { apiService } from '../../services/ApiService';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Loader from '../components/svg/Loader';
import LoadMoreButton from '../components/LoadMoreButton';
import { IPollsCollection } from '../../models/IPoll';
import Image from 'next/image';
import FallBackImage from '../components/FallBackImage';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import Participants from '../components/svg/Participants';
import PollIcon from '../components/svg/PollIcon';
import SectionTitle from '../components/SectionTitle';
import PollDateRenderer from './PollDateRenderer';


interface Props {
  initialCollections: IPaginatedData<IPollsCollection>;
}

export default function CollectionsWrapper({initialCollections}:Props) {
  const [page, setPage] = useState(initialCollections.page);

  const {
    data,
    isFetching,
    isLoading,
    fetchNextPage,
    hasPreviousPage,
    fetchPreviousPage,
    hasNextPage
  } = useInfiniteQuery({
    retry: false,
    initialData: () => {
      return {
        pageParams: [undefined, page],
        pages: [initialCollections]
      }
    },
    enabled: false,
    queryKey: ['collections'],
    queryFn: async ({ pageParam = page }) => {
      const result = await apiService.listPollCollections({page: pageParam as number, pageSize: initialCollections.pageSize});
      const isPrev = page > pageParam;
      if (isPrev) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
      setPage(result.page);
      return result;
    },
    getPreviousPageParam: (firstPage, allPages) => {
      // If the first page in our data array is page 1, there is no previous
      return firstPage.page > 1 ? firstPage.page - 1 : undefined;
    },
    getNextPageParam: (lastPage, allPages, lastPageParam, allPagesParam) => {
      if (!lastPage) return 1;
      return lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined;
    },
    initialPageParam: page
  });


  useEffect(() => {
    // setQueryParam({page});
  }, [page]);
const totalData = useMemo(() => {
  const allCollections = (data?.pages?.map(p => p.data).flat(Infinity) || []) as IPollsCollection[];
  return Array.from(
    new Map(allCollections.map(col => [col.slug, col])).values()
  );
}, [data]) as IPollsCollection[];


  return (
    <div className='flex flex-col gap-[24px] mx-auto tablet:max-w-[860px] w-full'>
      <SectionTitle title='استطلاعات'/>

      <div className='flex flex-col gap-[24px]'>
      {totalData.map((x,i) => {
        
        return (
          <div className='flex flex-col tablet:flex-row items-start rounded-[12px] tablet:h-[190px] w-full shadow-post dark:bg-transparent dark:shadow-pollCollectionCardDark dark:border dark:border-[#3e3e3e]'>
            
      <FallBackImage src={x.image} thumbnail={x.image} alt={x.imageAlt || ''}  className={twMerge('w-full tablet:w-[260px] h-full object-cover rounded-t-[12px] tablet:rounded-tl-none tablet:rounded-r-[12px]')} />

      <div className='flex flex-col py-[24px] px-[16px] gap-[16px] flex-1 h-full justify-between rounded-l-[12px] w-full'>
        <div className='flex flex-col gap-[12px]'>
            <h5>{x.titleAr}</h5>
          <span className='sm'>{x.descriptionAr}</span>
          </div>

            <div className='flex items-center gap-[24px] justify-between flex-wrap'>
          <Link href={`/voting/${x.slug}`} className='bg-gray-0 rounded-[8px] px-[12px] h-[38px] grid place-items-center dark:bg-quaternary whitespace-nowrap'>
            بدء الاستطلاعات
            </Link>

            <div className='flex items-center gap-[6px]'>
              <span className='sm whitespace-nowrap'>{x.pollCount} إجمالي الاستطلاعات</span>
              <PollIcon className='dark:[&>*]:stroke-white'/>
              </div>

          </div>
        </div>
      
          </div>
      )
})}
</div>

<div className='flex items-center justify-center mx-auto gap-[12px]'>
  {isLoading || isFetching ? <Loader/>: (
    <>
    {hasNextPage ? <LoadMoreButton text='المزيد' onClick={fetchNextPage}/> : null}
    {hasPreviousPage ? <LoadMoreButton text='السابق' onClick={fetchPreviousPage}/> : null}
    </>
  )}
</div>
    </div>
  )
}